<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Body-Text-No-Indent-SpB4--Body-"><span class="bold _idGenCharOverride-1">The Chicago Railroad Fair</span>, held in the summer and early fall of 1948 and 1949, commemorated the 100th anniversary of the city’s first train service. Said to be the last great rail exposition held in the U.S., the fair was mounted on a narrow, 50-acre strip along Lake Michigan some two miles south of the city’s Loop business district.</p>
<p class="ORIM-Body-Text-Indented--Body-">Although hastily arranged during the winter and spring of 1948, the fair quickly gained the support and participation of 38 railroads, many of them eager to use the event as a way of promoting and revitalizing passenger traffic and displaying new equipment in the aftermath of World War II.</p>
<p class="ORIM-Body-Text-Indented--Body-">The popularity of the fair in 1948 emboldened its organizers to bring it back for a second year, much as the city’s Century of Progress World’s Fair fifteen years earlier was held over for a second year based on the success of the first.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Goldsborough_TerrorAtTheFair_1P-2Copy.vue?7cda07f2